import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Modal from 'react-awesome-modal';
import Table from '../components/table/table';
import ModalComponent from '../components/modal';
import TableUserFilter from '../components/table/userFilter';
import DateComponent from '../components/date/Date';
import TableRegisterButton from '../components/table/registerButton';
import ClientsAction from '../app/store/actions/clients';

import { getUsers, updateUserClientStatus } from '../app/store/actions/users';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

import TRANSLATE from '../helpers/translate';

class UsersPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clientId: props.location.item && props.location.item.clientId,
      limit: 20,
      page: 1,
      search: '',
      type: '',
      status: '',
      orderBy: 'ASC',
      field: 'userId',
      standardDays: 1,
      showModal: false,
      showModalNoData: false,
      modal: {},
      iniDate: new Date(),
      finDate: new Date(),
    };
  }

  componentDidMount() {
    const { clientId } = this.state;
    if (clientId) {
      this.searchUsers();
    } else {
      history.push(ROUTES.CLIENTS);
    }
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchUsers();
  }

  searchUsers = async () => {
    const {
      clientId, search, page, limit, type, status, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems(limit, skip, clientId, search, type, status, orderBy, field);
  }

  activeUser = async (userId, status) => {
    const { clientId } = this.state;
    try {
      await this.props.updateUserStatus(clientId, userId, status);
      await this.searchUsers();
    } catch (error) {
      const errorData = !!(error.response && error.response.data);
      if (errorData && error.response.data.error.code === 1306) {
        this.setState({
          showModalNoData: true,
          modal: {
            title: I18n.t('deactivatedClient'),
            body: I18n.t('customerDisabledNotice'),
            okBtn: I18n.t('ok'),
            action: false,
          },
        });
      } else if (errorData && error.response.data.error.code === 1615) {
        this.setState({
          showModalNoData: true,
          modal: {
            title: I18n.t('statusContact'),
            body: I18n.t('sphereUpdateContactError'),
            okBtn: I18n.t('ok'),
            action: false,
          },
        });
      } else {
        this.setState({
          showModalNoData: true,
          modal: {
            title: I18n.t('deactivatedClient'),
            body: I18n.t('errorOcurred'),
            okBtn: I18n.t('ok'),
            action: false,
          },
        });
      }
    }
  }

  selectType = async (value) => {
    await this.setState({ type: value, page: 1 });
    await this.searchUsers();
  }

  selectStatus = async (value) => {
    await this.setState({ status: value, page: 1 });
    await this.searchUsers();
  }

  selectStandardDays = async (value) => {
    const standardDate = document.querySelector('#standardDate');
    const betweenDates = document.querySelector('#betweenDates');

    if (value === 0) {
      standardDate.classList.remove('btn-dark');
      betweenDates.classList.remove('btn-outline-dark');
      standardDate.classList.add('btn-outline-dark');
      betweenDates.classList.add('btn-dark');
    } else {
      standardDate.classList.remove('btn-outline-dark');
      betweenDates.classList.remove('btn-dark');
      standardDate.classList.add('btn-dark');
      betweenDates.classList.add('btn-outline-dark');
    }
    await this.setState({ standardDays: value });
  }

  initialDate = async (value) => {
    value = value.split('-');
    value = new Date(`${value[2]}-${value[1]}-${value[0]} 06:00:00`);
    await this.setState({ iniDate: value });
  }

  finalDate = async (value) => {
    value = value.split('-');
    value = new Date(`${value[2]}-${value[1]}-${value[0]} 06:00:00`);
    await this.setState({ finDate: value });
  }

  selectExportAccessCsv = async (value) => {
    const {
      clientId, iniDate, finDate, standardDays,
    } = this.state;
    if (!value) {
      const result = await this.props.getCsvUsersAccessReport(clientId, standardDays, iniDate, finDate);
      if (!result) {
        this.failedModal();
      }
    }
    await this.setState({ showModal: value });
  }

  failedModal = async () => {
    await this.setState({
      showModalNoData: true,
      modal: {
        title: I18n.t('noData'),
        body: I18n.t('noDataPeriod'),
        okBtn: I18n.t('ok'),
        action: false,
      },
    });
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchUsers();
  }

  render() {
    const {
      limit, page, type, status, iniDate, finDate, standardDays, showModal, showModalNoData, modal,
    } = this.state;
    const { users = {} } = this.props;

    const tableHeader = [
      { key: 'userId', value: 'ID' },
      { key: 'email', value: I18n.t('email') },
      { key: 'name', value: I18n.t('name') },
      { key: 'role', value: I18n.t('type') },
      { key: 'lastAcess', value: I18n.t('lastAcess') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = (users.rows || []).map((row, index) => ({
      key: index,
      userId: row.user.id,
      email: row.user.email,
      name: row.user.name,
      lastAcess: row.user.lastAccess ? new Date(row.user.lastAccess).toLocaleString() : '',
      role: TRANSLATE.userType(row.user.role),
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${row.status === 'active' ? 'warning' : 'dark'} promotion-btn-${
              row.status === 'active' ? 'warning' : 'active'}`}
            onClick={() => this.activeUser(row.userId, row.status === 'active' ? 'inactive' : 'active')}
          >
            <Translate value={row.status === 'active' ? 'disable' : 'active'} />
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                onClick={() => history.push({
                  pathname: ROUTES.FORM,
                  screenComming: 'users',
                  item: row,
                  client: this.props.location.item,
                })}
                className="dropdown-item dropdown-table"
              >
                <Translate value="edit" />
              </button>
            </div>
          </div>
        </div>
      ),
    }));


    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{
          pathname: ROUTES.FORM, screenComming: 'users', item: '', client: this.props.location.item,
        }}
        />
        <button
          onClick={() => history.push({ pathname: ROUTES.UPLOAD_USERS, screenComming: 'users' })}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="import" />
        </button>

        <button
          onClick={() => this.selectExportAccessCsv(true)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>

      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        {showModal && (
          <Modal
            visible={showModal}
            width="600"
            height="300"
            effect="fadeInUp"
            onClickAway={() => this.setState({ showModal: false })}
          >
            <div>
              <div className="row justify-content-center">
                <div className="col-5">
                  <button
                    id="standardDate"
                    onClick={() => this.selectStandardDays(1)}
                    type="button"
                    className="btn btn-dark btn-lg"
                  >
                    <Translate value="ExportSixtyDays" />
                  </button>
                </div>

                <div className="col-5">
                  <button
                    id="betweenDates"
                    onClick={() => this.selectStandardDays(0)}
                    type="button"
                    className="btn btn-outline-dark btn-lg"
                  >
                    {`${I18n.t('initDate')} e ${I18n.t('finDate')}`}
                  </button>
                </div>
              </div>

              <br />

              { standardDays === 0 && (
                <div className="modal-body">
                  <div className="row justify-content-center">
                    <div className="col-4">
                      <DateComponent
                        title={I18n.t('initDate')}
                        value={iniDate}
                        dateFormat="DD-MM-YYYY"
                        onChange={e => this.initialDate(e)}
                      />
                    </div>

                    <div className="col-4">
                      <DateComponent
                        title={I18n.t('finDate')}
                        value={finDate}
                        dateFormat="DD-MM-YYYY"
                        onChange={e => this.finalDate(e)}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="modal-footer">
                <button
                  onClick={() => this.selectExportAccessCsv(false)}
                  type="button"
                  className="btn btn-secondary btn-lg"
                >
                  <Translate value="export" />
                </button>
              </div>
            </div>
          </Modal>
        )}

        <ModalComponent
          title={modal.title}
          body={modal.body}
          visible={showModalNoData}
          closeModal={() => this.setState({ showModalNoData: false })}
          titleOkButtoon={modal.okBtn}
          size={{ width: '420px', height: '190px' }}
          showButtons
          showCancel={modal.action}
          confirmModal={() => this.setState({ showModalNoData: false })}
        />

        <Table
          title={I18n.t('users')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          extras={(
            <TableUserFilter
              type={type}
              status={status}
              selectType={this.selectType}
              selectStatus={this.selectStatus}
            />
          )}
          page={page}
          perPage={limit}
          count={users.count}
          searchItems={this.updateValues}
          clientData={this.props.location.item}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchItems: (limit, skip, clientId, search, type, status, order, field) => dispatch(
    getUsers(limit, skip, clientId, search, type, status, order, field),
  ),
  updateUserStatus: (clientId, userId, status) => dispatch(updateUserClientStatus(clientId, userId, status)),

  getCsvUsersAccessReport: (clientId, standardDays, iniDate, finDate) => dispatch(
    ClientsAction.getCsvUsersAccessReport(clientId, standardDays, iniDate, finDate),
  ),
});

const mapStateToProps = state => ({
  users: state.users.users,
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);
